/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Mcp_Servers_Test_FailedInputs */



/**
* | output |
* | --- |
* | "Connection failed: {error}" |
*
* @param {Mcp_Servers_Test_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_test_failed = /** @type {((inputs: Mcp_Servers_Test_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Test_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verbindung fehlgeschlagen: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Connection failed: ${i?.error}`)
});